import React, { useContext } from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faUnlink, faTrash } from "@fortawesome/free-solid-svg-icons";

import RootField from "./root-field";
import VarietyHead from "./variety-head";

import { TaskContext } from "contexts/task";
import { findField } from "components/attributes/compare-table/field-builder";
import * as notify from "shared/notify";

const filterLinkableOptions = (data, id, unusableVarieties, isParent) => {
    return isParent
        ? []
        : data.reduce((arr, o) => {
              if (o.value !== id && !unusableVarieties.includes(o.value)) {
                  arr.push(o);
              }

              return arr;
          }, []);
};

const VarietyItem = ({
    id,
    name,
    linkCode,
    isParent,
    sharedValues,
    packAttributes,
    attributeList,
    attributeListMap,
    removeVariety,
    updateVariety,
    updateVarietyAttribute,
    removeVarietyAttribute,
    varieties,
    varietiesWithLinks,
}) => {
    const { task } = useContext(TaskContext);

    const handleAttributeLink = async (attribute, defaultValue, isLinked) => {
        if (!isLinked && defaultValue) {
            const isConfirmed = await notify.confirm("Are you sure you want to link the attribute?");

            if (!isConfirmed) {
                return;
            }
        }

        updateVarietyAttribute(attribute, null, id, true);
    };

    return (
        <>
            <VarietyHead
                variety={name}
                linkCode={linkCode}
                isParent={isParent}
                varietyId={id}
                removeVariety={removeVariety}
                updateVariety={updateVariety}
                linkableOptions={filterLinkableOptions(varieties, id, varietiesWithLinks, isParent)}
            />
            {attributeList.map((attr) => {
                const isLinked = sharedValues.includes(attr.uuid);
                const Field = findField(attr.componentType, isLinked);
                const defaultValue = packAttributes && packAttributes[attr.uuid] ? packAttributes[attr.uuid] : "";
                const linkedAttributes =
                    attr.additionalInfo && attr.additionalInfo.linkedAttributes
                        ? attr.additionalInfo.linkedAttributes.map((u) => {
                              return attributeListMap[u].name;
                          })
                        : [];

                return (
                    <div key={`VPF_${attr.uuid}_${id}`} className={classnames("variety-item", { "-linked": isLinked })}>
                        <div className="variety-field">
                            <RootField
                                key={`VPF_${attr.uuid}_${id}`}
                                Field={Field}
                                attribute={attr}
                                isCompleted={task.isCompleted}
                                updateVarietyAttribute={updateVarietyAttribute}
                                defaultValue={defaultValue}
                                varietyId={id}
                                readOnly={isLinked}
                            />
                            {linkedAttributes.length > 0 && <div className="memo">Related attributes: {linkedAttributes.join(", ")}</div>}
                        </div>
                        <div className="button-group">
                            {!isLinked && defaultValue && (
                                <button
                                    className="button -text"
                                    title="Delete"
                                    onClick={() => {
                                        removeVarietyAttribute(attr.uuid, id);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            )}
                            {linkCode && (
                                <button
                                    className="button -text"
                                    title={isLinked ? "Unlink" : "Link"}
                                    onClick={() => handleAttributeLink(attr, defaultValue, isLinked)}
                                >
                                    <FontAwesomeIcon icon={isLinked ? faLink : faUnlink} />
                                </button>
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default VarietyItem;
